module.exports = __webpack_public_path__ + "img/login_img.58132253.png";